import React, { Component } from 'react';


class Start extends Component {
  render() {
    return (
      <div className="survey">
        <div className='row'>
          <div className='col-1'></div>
          <div className='col-10'>
            <h1 className='title center'> Welcome to the Minnesota Nursing Informatics Leadership Inventory™ </h1>
            <p>
              We invite you to complete the Minnesota Nursing Informatics Leadership Inventory™ (MNILI™) as part of our research to understand how nursing informatics leaders around the world apply leadership skills in common informatics scenarios. Your participation will contribute in two ways. 
              First, your individual report will enable you to gain self-knowledge and plan for further leadership development. Second, data generated from MNILI™ will help to understand patterns in nursing informatics leadership and contribute to international nursing informatics leadership dialogues. 
              MNILI™ is copyrighted by the Regents of the University of Minnesota and is freely available for use by other researchers.
               <a href="mailto:mons0122@umn.edu" target="_top" className='blue'>For more information about this, send us an e-mail message.</a>
            </p>
            <p>
              This study is a collaboration between the Nursing Informatics and the Katharine J. Densford International Center for Nursing Leadership within the University of Minnesota School of Nursing. 
              The University of Minnesota deemed this study not human subjects research. This MNILI™ is adapted and derived from the competing values framework.
              <sub>1</sub> 
            </p>
            <p>
              Your participation is voluntary. 
              Whether you participate or not will not affect your relationship with the School of Nursing nor the University of Minnesota in any way. 
              No personal identifying information will be collected. 
              By completing this survey, you agree that your anonymous data may be used in the project, and included in publications or presentations. 
              There is no benefit to you personally from this study. 
              MNILI™ is copyrighted by the Regents of the University of Minnesota and is freely available for use by other researchers.
            </p>
            <p>After you have completed the MNILI, visit our <a href='/dashboard' className='blue'>dashboard</a> and compare your results with other nursing informatics leaders around the world.</p>

            <p>
              1. Cameron, K. S., & Quinn, R. E. (2011). Diagnosing and changing organizational culture: Based on the competing values framework. John Wiley & Sons.
            </p>
            <div className="start">
                <p className='b'> Completing the survey indicates your consent to participate. </p>
                <a className="btn btn-lg center red" href='/survey'> I Agree </a>
            </div>
          </div>
          <div className='col-1'></div>
        </div>
      </div>
    );
  }
}

export default Start;



// WEBPACK FOOTER //
// ./src/containers/start.js